<div class="floors-ifc-mapping-wrapper">
  <form [formGroup]="form">
    <mat-table [dataSource]="floorsFormArray.controls" formArrayName="Floors">
      <ng-container matColumnDef="Name">
        <mat-header-cell *matHeaderCellDef>{{ 'FloorsConfiguration.IfcMapping.IfcName' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let floor; let i = index">{{ getFormValueByKey("Name", i) }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="Floor">
        <mat-header-cell *matHeaderCellDef>{{ 'FloorsConfiguration.IfcMapping.FloorName' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let floor; let i = index" [formGroupName]="i">
          <mat-select formControlName="Floor">
            <mat-option *ngFor="let companyFloor of companyFloors"
                        [value]="companyFloor.Id">{{ companyFloor.Name }}</mat-option>
          </mat-select>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
  </form>
</div>
